module.exports = __webpack_public_path__ + "img/service4.468c763.png";